import moment, { Moment } from 'moment';

/**
 * Returns the correct datetime string format accepted by the backoffice API: no timezone specified
 * @param value
 */
export function getServerDateTimeFormat(value: any) {
    if (!value) return null;

    return moment(value).format('YYYY-MM-DDTHH:mm:ss');
}

/**
 * Returns the correct date string format accepted by the backoffice API: no timezone specified
 * @param dateValue
 */
export function getServerDateFormat(dateValue: Moment) {
    if (!dateValue) return null;

    return moment(dateValue).format('YYYY-MM-DD');
}

/**
 * Returns the correct time string format accepted by the backoffice API: no timezone specified
 * @param timeValue
 */
export function getServerTimeFormat(timeValue: string) {
    if (!timeValue) return null;

    let date = moment(new Date()).format(`YYYY-MM-DDT${timeValue}`);
    return moment(date).format('HH:mm:ss');
}
